import { type TCoordinates, getStorage, setStorage } from '@/shared/lib'

export const getCoordinates = () => {
  const coordinates = getStorage('coordinates')

  if (!coordinates) {
    return null
  }

  return JSON.parse(coordinates) as TCoordinates
}

export const setCoordinates = (coordinates: TCoordinates) => {
  setStorage('coordinates', JSON.stringify(coordinates))
}

type ZoomLevel = number

export const getZoomLevel = () => {
  const zoomLevel = getStorage('zoomLevel')

  if (!zoomLevel) {
    return null
  }

  return parseInt(zoomLevel)
}

export const setZoomLevel = (zoomLevel: ZoomLevel) => {
  setStorage('zoomLevel', zoomLevel.toString())
}
